/**
 * Controller for the large-web-project-notice directive.
 * @ngInject
 */
function LargeWebProjectNoticeController() {
}

module.exports = LargeWebProjectNoticeController;
